'use client';

import clsx from 'clsx';
import { usePathname } from 'next/navigation';
import { PropsWithChildren, useEffect, useRef } from 'react';

import { Footer } from './Footer';
import styles from './Layout.module.css';

export const Main = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (pathname.includes('/article')) return;
    const saved = sessionStorage.getItem(`scroll-${pathname}`);
    if (saved && ref.current) {
      ref.current?.scrollTo({
        top: Number(saved),
        left: 0,
      });
    }

    const setScroll = () => {
      sessionStorage.setItem(
        `scroll-${pathname}`,
        String(ref.current?.scrollTop ?? 0)
      );
    };

    ref.current?.addEventListener('scroll', setScroll);

    return () => {
      ref.current?.removeEventListener('scroll', setScroll);
    };
  }, [pathname, ref]);

  return (
    <main className={clsx(styles.main, 'scroll')} ref={ref}>
      {children}
      <Footer />
    </main>
  );
};
